import React from 'react';
import { Table as AntdTable, TableProps } from 'antd';
import styled from '@emotion/styled';
import { TextCell } from './Cells/TextCell';
import { InspectionStaticCell } from './Cells/InspectionStaticCell';

const StyledTable = styled(AntdTable)`
  .ant-table-tbody > tr > td {
    word-wrap: break-word;
    word-break: break-all;
  }
  thead {
    th {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0.005em;
      text-align: left;

      &:before {
        display: none;
      }
    }
  }
  tbody {
    .ant-table-cell {
      cursor: default;
    }
    > tr > td {
      word-wrap: break-word;
      word-break: break-all;
    }
  }
`;

const Table = (props: TableProps<any>) => {
  return <StyledTable {...props} />;
};

export default Table;
export { TextCell, InspectionStaticCell };
